"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var area = _interopRequireWildcard(require("@/api/area"));
var _date = require("@/utils/date");
var _elementUiElTableDraggable = _interopRequireDefault(require("element-ui-el-table-draggable"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ElTableDraggable: _elementUiElTableDraggable.default
  },
  data: function data() {
    return {
      dialogWidth: "1000px",
      tableData: [],
      tempData: {},
      dialogStatus: "",
      dialogVisible: false,
      loadingButton: false,
      rules: {
        name: {
          required: true,
          message: "Vui lòng nhập tên",
          trigger: "submit"
        }
      }
    };
  },
  methods: {
    formatDateTime: function formatDateTime(n) {
      return (0, _date.formatDateTime)(n);
    },
    getTableData: function () {
      var _getTableData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return area.findAll({
                page: 1,
                limit: 0
              });
            case 2:
              res = _context.sent;
              this.tableData = res.data.areas;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableData() {
        return _getTableData.apply(this, arguments);
      }
      return getTableData;
    }(),
    updateData: function updateData() {
      var _this = this;
      var data = {
        areas: this.tableData.map(function (item, index) {
          return {
            id: item.id,
            position: index + 1
          };
        })
      };
      this.loadingButton = true;
      area.sort(data).then(function (res) {
        if (res.status) {
          _this.$notify({
            type: "success",
            message: "Cập nhật khu vực thành công"
          });
          _this.dialogVisible = false;
          _this.$emit("update:success");
        }
      }).finally(function () {
        _this.loadingButton = false;
      });
    },
    preventDefaultDragable: function preventDefaultDragable() {
      document.addEventListener("dragstart", function (event) {
        var img = new Image();
        img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=";
        event.dataTransfer.setDragImage(img, 0, 0);
      }, false);
    },
    handleOpen: function handleOpen(tableData) {
      this.dialogVisible = true;
      this.getTableData();
    }
  },
  mounted: function mounted() {
    this.preventDefaultDragable();
  }
};